/**
 * Chooses the next camera to select after one has been deleted.
 * @param {Object} args - Object to be deconstructed which contains arguments.
 * @param {Array} args.cameraIds
 * @param {Number} args.id
 * @return {Number} Camera id to select.
 */

export default function chooseProperCameraToShift({ cameraIds, id }) {
  const sortedIds = cameraIds.sort((a, b) => a - b)
  if (sortedIds.indexOf(id) < 1) {
    return sortedIds[1]
  } else {
    return sortedIds[sortedIds.indexOf(id) - 1]
  }
}



// WEBPACK FOOTER //
// ./src/helpers/cameras/chooseProperCameraToShift.js